export const env = {
    message: {
        no_internet: 'You probably may not have internet!',
        required_fields: 'Please fill up required fields!',
        valid_email: 'Enter a valid email address!'
    }
}
